import React from 'react';
import { BookOpen } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { useInView } from '../hooks/useInView';
const tomos = [{
  number: '1',
  title: 'Diagnóstico Financiero: Conocé tu punto de partida',
  benefit: 'Vas a ver con claridad total a dónde va cada peso que entra hoy'
}, {
  number: '2',
  title: 'El Sistema de Presupuesto Inverso',
  benefit: 'Vas a implementar el método central que reorganiza todo tu flujo de dinero'
}, {
  number: '3',
  title: 'Deudas al Suelo: Liquidá lo que te frena',
  benefit: 'Vas a tener un plan concreto para eliminar deudas sin entrar en pánico'
}, {
  number: '4',
  title: 'Tu Primer Fondo de Emergencia',
  benefit: 'Vas a construir un colchón financiero que te da tranquilidad real'
}, {
  number: '5',
  title: 'Primeros Pasos para Invertir con Sueldo Fijo',
  benefit: 'Vas a saber exactamente cómo hacer que tu dinero trabaje para vos'
}, {
  number: '6',
  title: 'Mentalidad Caudal: El lado mental del dinero',
  benefit: 'Vas a reprogramar los patrones que te hicieron llegar hasta acá'
}];
export function ProductPresentation() {
  const {
    ref: headerRef,
    isVisible: headerVis
  } = useInView();
  const {
    ref: gridRef,
    isVisible: gridVis
  } = useInView();
  return <section className="py-24 px-4" data-id="element-238">
      <div className="max-w-5xl mx-auto" data-id="element-239">
        <div ref={headerRef} className={`text-center mb-16 ${headerVis ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-240">
          <h2 className="font-serif text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-241">
            MÉTODO CAUDAL:
            <br data-id="element-242" />
            <span className="text-gold-500" data-id="element-243">DOMINA TU DINERO</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-3xl mx-auto mb-8" data-id="element-244">
            El Pack de 6 Tomos que te lleva de "no sé a dónde se fue" a "sé
            exactamente qué pasa con cada peso"
          </p>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-245">
            Este no es otro libro de "consejos financieros" que te dice lo que
            ya sabés.
            <br data-id="element-246" />
            <br data-id="element-247" />
            <strong className="text-white" data-id="element-248">
              Método Caudal es un sistema completo, paso a paso, diseñado
              específicamente para personas que cobran un sueldo y quieren
              construir riqueza real desde cero.
            </strong>
          </p>
        </div>

        <div className="mb-16" data-id="element-249">
          <h3 className="text-center text-sm font-bold text-gold-500 uppercase tracking-[0.2em] mb-10" data-id="element-250">
            LO QUE INCLUYE EL PACK COMPLETO:
          </h3>
          <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-251">
            {tomos.map((tomo, index) => <div key={index} className={`bg-[#141414] border border-gray-800 hover:border-gold-500/50 transition-colors duration-300 rounded-2xl p-6 flex flex-col h-full ${gridVis ? `anim-fade-up anim-delay-${index + 1}` : 'anim-hidden'}`} data-id="element-252">
                <div className="flex items-center gap-3 mb-4" data-id="element-253">
                  <div className="w-10 h-10 rounded-full bg-gold-500/10 flex items-center justify-center text-gold-500 font-bold" data-id="element-254">
                    {tomo.number}
                  </div>
                  <BookOpen className="w-5 h-5 text-gray-600" data-id="element-255" />
                </div>
                <h4 className="font-serif text-xl font-bold text-white mb-3" data-id="element-256">
                  {tomo.title}
                </h4>
                <p className="text-gray-400 text-sm mt-auto" data-id="element-257">{tomo.benefit}</p>
              </div>)}
          </div>
        </div>

        <div className="mt-16" data-id="element-258">
          <CTAButton data-id="element-259" />
        </div>
      </div>
    </section>;
}